import { render } from "./CountrySelector.vue?vue&type=template&id=53cffe1d&scoped=true&lang=pug"
import script from "./CountrySelector.vue?vue&type=script&lang=js"
export * from "./CountrySelector.vue?vue&type=script&lang=js"

import "./CountrySelector.vue?vue&type=style&index=0&id=53cffe1d&scoped=true&lang=sass"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53cffe1d"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QMenu});qInstall(script, 'directives', {ClosePopup});
